var _defs, _line, _text, _circle, _line2, _text2, _circle2, _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _rect, _rect2, _text3, _circle3, _line3, _line4, _text4, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIvm2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 418.96 452.38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-5{fill:none;stroke:#6b7b84;stroke-miterlimit:10;stroke-width:0.5px;}.cls-2{font-size:8px;font-family:ProximaNova-Regular, Proxima Nova;}.cls-2,.cls-4{fill:#812990;}.cls-3{fill:#d5ddeb;}.cls-5{stroke-dasharray:2 2;}.cls-6{fill:#6b7b84;}.cls-7{fill:#231f20;}"))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.73,
    y1: 348.9,
    x2: 86.93,
    y2: 348.9
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(4.56 351.68)"
  }, "1")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.92,
    cy: 348.9,
    r: 5.67
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 11.73,
    y1: 192.48,
    x2: 86.93,
    y2: 192.48
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(3.56 195.26)"
  }, "2")), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 5.92,
    cy: 192.48,
    r: 5.67
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "418.72 402.12 418.72 402.12 197.61 33.62 418.72 33.62 418.72 402.12"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "418.72 402.12 308.17 217.87 197.61 402.12 418.72 402.12"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "87.06 70.47 197.61 70.47 289.74 217.87 234.46 310 87.06 310 87.06 70.47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.81,376.39v.86H87.06v-4.88h3.6v.86H88v1.24h2.21v.83H88v1.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M96.05,372v5.22h-1V377a2.19,2.19,0,0,1-1.09.29,1.94,1.94,0,0,1,0-3.88,2.29,2.29,0,0,1,1.09.28V372Zm-1,4.09v-1.51a1.39,1.39,0,0,0-.92-.32A1.07,1.07,0,0,0,93,375.37a1,1,0,0,0,1.12,1.07A1.41,1.41,0,0,0,95.08,376.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M101.26,373.49v3.76h-1V377a1.76,1.76,0,0,1-1,.31c-1.11,0-1.61-.51-1.61-1.73v-2.09h1v2.09c0,.58.29.86.82.86a1.26,1.26,0,0,0,.85-.3v-2.65Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.24,376.55a1.8,1.8,0,0,1-1.46.76,1.94,1.94,0,1,1,0-3.88,1.82,1.82,0,0,1,1.47.74l-.62.58a1,1,0,0,0-.85-.46,1.08,1.08,0,1,0,0,2.15,1,1,0,0,0,.85-.46Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M111.47,373.49v3.76h-1V377a2,2,0,0,1-1.1.33,1.95,1.95,0,0,1,0-3.89,2.17,2.17,0,0,1,1.1.31v-.24Zm-1,1.13a1.39,1.39,0,0,0-.93-.33,1.08,1.08,0,1,0,0,2.15,1.41,1.41,0,0,0,.93-.32Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M114.29,374.29v1.33c0,.67.12.86.6.86.17,0,.31,0,.44,0v.72a2.41,2.41,0,0,1-.87.14,1.09,1.09,0,0,1-1.14-1.19v-1.83h-.53v-.8h.53V372h1v1.46h1.06v.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.7,372.53a.56.56,0,0,1,.55-.57.57.57,0,1,1-.55.57Zm.08,1h1v3.76h-1Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M123.35,375.37a2.06,2.06,0,1,1-2.06-1.94A2,2,0,0,1,123.35,375.37Zm-.95,0a1.11,1.11,0,1,0-1.11,1.07A1.09,1.09,0,0,0,122.4,375.37Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M128.4,375.16v2.09h-1v-2.09c0-.59-.29-.87-.82-.87a1.2,1.2,0,0,0-.83.3v2.66h-1v-3.76h1v.24a1.74,1.74,0,0,1,1-.3C127.89,373.43,128.4,373.94,128.4,375.16Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M137.23,375.09a9.72,9.72,0,0,1-.74,1.11l.59.57-.58.54-.54-.54a2.12,2.12,0,0,1-1.3.54c-1.12,0-1.84-.53-1.84-1.42a1.47,1.47,0,0,1,1-1.31,1.29,1.29,0,0,1-.43-.94,1.39,1.39,0,0,1,2.77-.1,1.49,1.49,0,0,1-1.06,1.33l.84.8a5.46,5.46,0,0,0,.58-.81Zm-1.78,1.14-1.09-1.06c-.39.16-.58.4-.58.68s.33.68.92.68A1.14,1.14,0,0,0,135.45,376.23Zm-1.23-2.56a1,1,0,0,0,.43.7c.31-.1.72-.32.72-.71a.58.58,0,0,0-.59-.64A.6.6,0,0,0,134.22,373.67Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M145.25,372.37h1.08l-2.28,4.88h-.46l-2.27-4.88h1.08l1.42,3.19Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.55,372.53a.56.56,0,0,1,.55-.57.57.57,0,1,1-.55.57Zm.07,1h1v3.76h-1Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M150.42,376.23a2.91,2.91,0,0,0,1.29.31c.44,0,.62-.17.62-.36s-.22-.31-.8-.44c-.81-.18-1.4-.44-1.4-1.17s.56-1.14,1.44-1.14a3.67,3.67,0,0,1,1.46.3l-.31.71a3.51,3.51,0,0,0-1.17-.25c-.37,0-.56.13-.56.34s.23.3.83.42c.88.18,1.38.49,1.38,1.17s-.55,1.19-1.51,1.19a3.33,3.33,0,0,1-1.63-.36Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.44,373.49v3.76h-1V377a2,2,0,0,1-1.1.33,1.95,1.95,0,0,1,0-3.89,2.19,2.19,0,0,1,1.1.31v-.24Zm-1,1.13a1.41,1.41,0,0,0-.93-.33,1.08,1.08,0,1,0,0,2.15,1.43,1.43,0,0,0,.93-.32Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.87,375.82c0,.94-.76,1.49-1.89,1.49a3.74,3.74,0,0,1-2-.46l.36-.77a3.47,3.47,0,0,0,1.7.38c.54,0,.85-.2.85-.56s-.32-.47-1-.64c-1-.23-1.82-.51-1.82-1.47s.69-1.47,1.8-1.47a4.72,4.72,0,0,1,1.87.39l-.4.79a4.28,4.28,0,0,0-1.49-.32c-.5,0-.77.22-.77.52s.34.49,1.08.66C166.15,374.59,166.87,374.93,166.87,375.82Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M169.15,375.65a1,1,0,0,0,1.08.83,1.22,1.22,0,0,0,1-.46l.61.51a2.07,2.07,0,0,1-1.7.78,1.94,1.94,0,0,1,0-3.88,1.8,1.8,0,0,1,1.83,2v.22Zm0-.62H171a.83.83,0,0,0-.91-.84A1,1,0,0,0,169.16,375Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M174.38,374a1.43,1.43,0,0,1,1.19-.59.62.62,0,0,1,.23,0v1a3,3,0,0,0-.46-.05.9.9,0,0,0-1,1v1.81h-1v-3.76h1Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M181,373.49l-1.8,3.76h-.46l-1.81-3.76h1l1,2.14,1-2.14Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M182.24,372.53a.56.56,0,0,1,.55-.57.57.57,0,1,1-.55.57Zm.07,1h1v3.76h-1Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M188.29,376.55a1.8,1.8,0,0,1-1.46.76,1.94,1.94,0,1,1,0-3.88,1.82,1.82,0,0,1,1.47.74l-.62.58a1,1,0,0,0-.85-.46,1.08,1.08,0,1,0,0,2.15,1,1,0,0,0,.85-.46Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M190.42,375.65a1,1,0,0,0,1.07.83,1.21,1.21,0,0,0,1-.46l.62.51a2.08,2.08,0,0,1-1.7.78,1.94,1.94,0,0,1,0-3.88,1.8,1.8,0,0,1,1.83,2c0,.08,0,.15,0,.22Zm0-.62h1.87a.84.84,0,0,0-.91-.84A1,1,0,0,0,190.42,375Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M194.83,376.23a2.91,2.91,0,0,0,1.29.31c.45,0,.62-.17.62-.36s-.22-.31-.8-.44c-.81-.18-1.4-.44-1.4-1.17s.56-1.14,1.44-1.14a3.72,3.72,0,0,1,1.47.3l-.32.71a3.51,3.51,0,0,0-1.17-.25c-.37,0-.56.13-.56.34s.23.3.83.42c.88.18,1.38.49,1.38,1.17s-.55,1.19-1.51,1.19a3.33,3.33,0,0,1-1.63-.36Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M194.22,335.22h-.92v2.62h-.54v-2.62h-.93v-.54h2.39Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M197.61,334.68v3.16h-.54V335.6l-1,1.61-1-1.61v2.24h-.54v-3.16H195l1,1.54,1-1.54Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M111,342.87v1a7.47,7.47,0,0,0-1.79-1,6.74,6.74,0,0,0-2.33-.38,7.12,7.12,0,0,0-2.72.52,6.57,6.57,0,0,0-3.57,3.58,6.91,6.91,0,0,0,0,5.21,6.6,6.6,0,0,0,3.57,3.57,6.94,6.94,0,0,0,2.72.52h.27a7.15,7.15,0,0,0,2.74-.52v-3.61h0a3.85,3.85,0,0,1-1.26.8,4.08,4.08,0,0,1-1.47.27,4.34,4.34,0,0,1-.63-.05h0a3.75,3.75,0,0,1-.86-.22,3.74,3.74,0,0,1-2.37-3.37,3.45,3.45,0,0,1,1.13-2.59,3.81,3.81,0,0,1,1.24-.79,4.15,4.15,0,0,1,1.49-.28,3.83,3.83,0,0,1,2.73,1.07,3.44,3.44,0,0,1,1.12,2.59v6.69h3.21V342.87Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M97.39,355.94l-7.12-6.87v6.87H87.06v-18.1h3.21v6.84l7.12-6.81h4.55l-9.39,9,9.39,9.06Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M122.55,342.54a6,6,0,0,1,2.39.47,5.59,5.59,0,0,1,1.83,1.3,5.89,5.89,0,0,1,1.18,1.92,6.69,6.69,0,0,1,.41,2.34v7.37h-3.21v-7.37a2.69,2.69,0,0,0-.94-2.11,3,3,0,0,0-2.19-.87,3.07,3.07,0,0,0-2.22.87,2.78,2.78,0,0,0-.91,2.11v7.37h-3.21v-13h3.21v1a6.43,6.43,0,0,1,1.63-1A5.48,5.48,0,0,1,122.55,342.54Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M166.09,342.9a5.66,5.66,0,0,1,2.16-.38v3.05a3.79,3.79,0,0,0-2.73,1.07,3.54,3.54,0,0,0-1.13,2.59v6.71h-3.21V342.87h3.21v1A6.9,6.9,0,0,1,166.09,342.9Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M175.51,342.54a7.44,7.44,0,0,1,2.76.52,7.11,7.11,0,0,1,2.25,1.44,6.6,6.6,0,0,1,1.51,2.14,6.44,6.44,0,0,1,0,5.21,6.67,6.67,0,0,1-1.51,2.13,7.11,7.11,0,0,1-2.25,1.44,7.25,7.25,0,0,1-2.76.52,7.2,7.2,0,0,1-5-2,6.67,6.67,0,0,1-1.51-2.13,6.44,6.44,0,0,1,0-5.21,6.6,6.6,0,0,1,1.51-2.14,7.11,7.11,0,0,1,2.25-1.44A7.35,7.35,0,0,1,175.51,342.54Zm0,3a3.83,3.83,0,0,0-2.73,1.07,3.53,3.53,0,0,0,0,5.16,3.52,3.52,0,0,0,1.25.8,4.19,4.19,0,0,0,3,0,3.71,3.71,0,0,0,1.25-.8,3.51,3.51,0,0,0,0-5.16A3.93,3.93,0,0,0,175.51,345.59Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M190.54,342.54a7.41,7.41,0,0,1,2.76.52,7.11,7.11,0,0,1,2.25,1.44,6.6,6.6,0,0,1,1.51,2.14,6.44,6.44,0,0,1,0,5.21,6.67,6.67,0,0,1-1.51,2.13,7.11,7.11,0,0,1-2.25,1.44,7.56,7.56,0,0,1-5.51,0,7.11,7.11,0,0,1-2.25-1.44,6.67,6.67,0,0,1-1.51-2.13,6.44,6.44,0,0,1,0-5.21,6.6,6.6,0,0,1,1.51-2.14,7.11,7.11,0,0,1,2.25-1.44A7.35,7.35,0,0,1,190.54,342.54Zm0,3a3.83,3.83,0,0,0-2.73,1.07,3.53,3.53,0,0,0,0,5.16,3.52,3.52,0,0,0,1.25.8,4.19,4.19,0,0,0,3,0,3.71,3.71,0,0,0,1.25-.8,3.51,3.51,0,0,0,0-5.16A3.93,3.93,0,0,0,190.54,345.59Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M156.19,342.87v1a7.28,7.28,0,0,0-1.79-1,6.74,6.74,0,0,0-2.33-.38,7.12,7.12,0,0,0-2.72.52,6.57,6.57,0,0,0-3.57,3.58,6.91,6.91,0,0,0,0,5.21,6.6,6.6,0,0,0,3.57,3.57,6.94,6.94,0,0,0,2.72.52h.27a7.15,7.15,0,0,0,2.74-.52v-3.61h0a3.85,3.85,0,0,1-1.26.8,4,4,0,0,1-1.47.27,4.46,4.46,0,0,1-.63-.05h0a3.75,3.75,0,0,1-.86-.22,3.74,3.74,0,0,1-2.37-3.37,3.45,3.45,0,0,1,1.13-2.59,3.81,3.81,0,0,1,1.24-.79,4.15,4.15,0,0,1,1.49-.28,3.83,3.83,0,0,1,2.73,1.07,3.44,3.44,0,0,1,1.12,2.59v6.69h3.21V342.87Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M140.62,342.87v1a7.28,7.28,0,0,0-1.79-1,6,6,0,0,0-1.16-.29,8.58,8.58,0,0,0-1.38-.11,6.66,6.66,0,0,0-2.67.52,6.15,6.15,0,0,0-2.09,1.44,6.55,6.55,0,0,0-1.35,2.13,7.09,7.09,0,0,0-.48,2.62h0a6.7,6.7,0,0,0,.51,2.6,6.6,6.6,0,0,0,3.57,3.57,6.94,6.94,0,0,0,2.72.52H137a7.14,7.14,0,0,0,2.54-.51v-3.61h0a3.85,3.85,0,0,1-1.26.8,4,4,0,0,1-1.47.27,4.46,4.46,0,0,1-.63-.05h0a3.75,3.75,0,0,1-.86-.22,3.4,3.4,0,0,1-1.24-.8,3.46,3.46,0,0,1-1.13-2.58,3.57,3.57,0,0,1,.27-1.35l0-.1a3.67,3.67,0,0,1,.82-1.13,3.81,3.81,0,0,1,1.24-.79,4.19,4.19,0,0,1,1.49-.28,3.83,3.83,0,0,1,2.73,1.07,3.48,3.48,0,0,1,.81,1.13s0,.07.05.1a3.58,3.58,0,0,1,.26,1.36v5.09a3.43,3.43,0,0,1-1.12,2.57,3.94,3.94,0,0,1-4.66.58l-2.33,2.19a7.34,7.34,0,0,0,7,.84,7.31,7.31,0,0,0,2.25-1.45,6.74,6.74,0,0,0,1.52-2.14,6.33,6.33,0,0,0,.54-2.59V342.87Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M90.79,367v.86H87.06V363h3.59v.86H88v1.23h2.2v.83H88V367Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M97,362.58v5.2H96v-.22a2.22,2.22,0,0,1-1.09.29,1.94,1.94,0,0,1,0-3.88,2.29,2.29,0,0,1,1.09.28v-1.67Zm-1,4.07v-1.5a1.44,1.44,0,0,0-.92-.32A1.07,1.07,0,0,0,94,365.91,1.06,1.06,0,0,0,95.07,367,1.41,1.41,0,0,0,96,366.65Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M103.08,364.05v3.74h-1v-.25a1.74,1.74,0,0,1-1,.31c-1.1,0-1.6-.51-1.6-1.73v-2.07h1v2.07c0,.58.28.86.81.86a1.3,1.3,0,0,0,.85-.29v-2.64Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M109,367.09a1.76,1.76,0,0,1-1.44.76,1.94,1.94,0,1,1,0-3.87,1.82,1.82,0,0,1,1.46.74l-.62.57a1,1,0,0,0-.84-.45,1.07,1.07,0,1,0,0,2.14,1,1,0,0,0,.84-.46Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.13,364.05v3.74h-1v-.27a2,2,0,0,1-1.09.33,1.94,1.94,0,0,1,0-3.88,2.16,2.16,0,0,1,1.09.31v-.23Zm-1,1.11a1.41,1.41,0,0,0-.92-.32,1.07,1.07,0,1,0,0,2.14,1.4,1.4,0,0,0,.92-.31Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M118.89,364.84v1.32c0,.67.11.87.59.87.17,0,.31,0,.45,0v.72a2.54,2.54,0,0,1-.87.14,1.08,1.08,0,0,1-1.13-1.18v-1.83h-.54v-.79h.54v-1.46h1v1.46h1v.79Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M122.23,363.13a.56.56,0,0,1,.55-.56.55.55,0,0,1,.55.56.54.54,0,0,1-.55.56A.55.55,0,0,1,122.23,363.13Zm.08,1h1v3.75h-1Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M129.79,365.91a2.05,2.05,0,1,1-2-1.93A2,2,0,0,1,129.79,365.91Zm-.94,0a1.11,1.11,0,1,0-1.11,1.07A1.09,1.09,0,0,0,128.85,365.91Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M135.76,365.76v2.09h-.95v-2.09c0-.58-.29-.87-.82-.87a1.22,1.22,0,0,0-.83.3v2.66h-.95V364.1h.95v.24a1.72,1.72,0,0,1,1-.31C135.26,364,135.76,364.54,135.76,365.76Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.29,363.84v1.73h2.33v.86h-2.33v1.42h-1V363H146v.86Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M152.19,365.91a2.05,2.05,0,1,1-2.05-1.93A2,2,0,0,1,152.19,365.91Zm-.94,0a1.11,1.11,0,1,0-1.11,1.07A1.09,1.09,0,0,0,151.25,365.91Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M158.14,364.05v3.74h-.95v-.25a1.79,1.79,0,0,1-1,.31c-1.09,0-1.6-.51-1.6-1.73v-2.07h1v2.07c0,.58.29.86.82.86a1.34,1.34,0,0,0,.85-.29v-2.64Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M164.3,365.76v2.09h-1v-2.09c0-.58-.28-.87-.82-.87a1.2,1.2,0,0,0-.82.3v2.66h-1V364.1h1v.24a1.67,1.67,0,0,1,1-.31C163.79,364,164.3,364.54,164.3,365.76Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M170.63,362.58v5.2h-1v-.22a2.22,2.22,0,0,1-1.09.29,1.94,1.94,0,0,1,0-3.88,2.32,2.32,0,0,1,1.09.28v-1.67Zm-1,4.07v-1.5a1.46,1.46,0,0,0-.92-.32,1.07,1.07,0,0,0-1.12,1.08,1.06,1.06,0,0,0,1.12,1.07A1.41,1.41,0,0,0,169.67,366.65Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M177,364.05v3.74h-1v-.27a2,2,0,0,1-1.1.33,1.94,1.94,0,0,1,0-3.88,2.19,2.19,0,0,1,1.1.31v-.23Zm-1,1.11a1.45,1.45,0,0,0-.93-.32,1.07,1.07,0,1,0,0,2.14,1.43,1.43,0,0,0,.93-.31Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M180.74,364.84v1.32c0,.67.11.87.59.87.17,0,.31,0,.44,0v.72a2.41,2.41,0,0,1-.87.14,1.08,1.08,0,0,1-1.13-1.18v-1.83h-.53v-.79h.53v-1.46h1v1.46h1v.79Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M184.08,363.13a.55.55,0,1,1,1.09,0,.55.55,0,1,1-1.09,0Zm.07,1h1v3.75h-1Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M191.64,365.91a2.05,2.05,0,1,1-2-1.93A2,2,0,0,1,191.64,365.91Zm-.95,0a1.11,1.11,0,1,0-1.1,1.07A1.08,1.08,0,0,0,190.69,365.91Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M197.61,365.76v2.09h-1v-2.09c0-.58-.28-.87-.81-.87a1.2,1.2,0,0,0-.83.3v2.66h-1V364.1h1v.24a1.7,1.7,0,0,1,1-.31C197.11,364,197.61,364.54,197.61,365.76Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 87.07,
    y: 334.44,
    width: 110.55,
    height: 42.82
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 50.2,
    y: 33.62,
    width: 368.5,
    height: 368.5
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(315.25 8.63)"
  }, "3")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 317.48,
    cy: 5.92,
    r: 5.67
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 317.47,
    y1: 51.56,
    x2: 317.47,
    y2: 11.63
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 306.56,
    y1: 440.79,
    x2: 306.56,
    y2: 345.78
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(304.32 449.17)"
  }, "4")), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 306.56,
    cy: 446.46,
    r: 5.67
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvm2);
export default __webpack_public_path__ + "static/media/ivm2.7d10a7a734de67d9d83a13a2da329790.svg";
export { ForwardRef as ReactComponent };